export default __webpack_public_path__ + "static/media/lettermark.1d03b28e.svg";